<template>
    <div class="text-center contents_modal">
        <v-dialog v-model="dialog" width="1000" relative persistent>
            <slot name="close">
                <div class="d-flex">
                    <v-btn icon @click="modal_open" dark class="ml-auto dialog__close ">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
            </slot>


            <v-card class="contents_modal__content">
                <v-card-title class="headline pt-5 pb-1  py-5">
                    <slot name="img">
                        <div class="img"></div>
                    </slot>
                    <slot name="title">
                        <div class="h2_title h2_title--modal"></div>
                    </slot>
                </v-card-title>

                <div class="contents_modal__descr" :style="{'height': autoheight+'px'}">
                    <vue-scroll :ops="ops_scrollbar">
                        <slot name="content">
                        </slot>
                    </vue-scroll>
                </div>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            ops_scrollbar: {
                vuescroll: {
                    wheelScrollDuration: 1000,
                    wheelDirectionReverse: true,
                    scroller: {
                        locking: true,
                    },
                },
                scrollPanel: {},
                scrollButton: {
                    // enable: true,
                    background: "#00ff40",
                    // opacity: 1,
                    // step: 180,
                    // mousedownStep: 30,
                },
                bar: {
                    background: "#eaeaea",
                    keepShow: true,
                    size: "5px",
                    minSize: 0.2,
                },
                rail: {
                    background: "#ffffff",
                    opacity: 0,
                    size: "8px",
                },
            },
            autoheight: '',
        };
    },
    methods: {
        autoheightcont() {
            let height;
            setTimeout(function () {
                height = document.querySelector('.v-dialog--active .contents_modal__descr');
                console.log(height.offsetHeight);
                if (height.length > 0 && height.offsetHeight > '450') {
                    this.autoheight = height.offsetHeight;
                }
            }, 500);

        },
        modal_open(event) {
            if (event == "scroll_false") {
                // console.log(event);
                // this.ops_scrollbar = '';
            }
            var video = document.querySelectorAll('video');
            video.forEach(function (item, index, array) {
                video[index].pause();
                // video[index].currentTime = 0;
            });


            function stopVideo() {
                video.pause();
                video.currentTime = 0;
            }

            if (this.dialog) {
                this.dialog = false;
                if ($('.contents_modal__descr iframe').length > 0) {
                    let iframe = $('.contents_modal__descr iframe');
                    let src = iframe.attr("src");
                    iframe.attr("src", src);
                }


            } else {
                this.dialog = true;
                this.autoheightcont();
            }
        },

    },
};
</script>
<style lang="scss">
@import "../../theme/_variable.scss";

.v-input--checkbox .v-messages.theme--light.error--text {
  margin-top: 5px !important;
  margin-left: 31px !important;
}

.contents_modal__content {

  & .h2_title--modal {
    border: none !important;
    display: flex;
    align-items: center;
  }

  & .v-card__title {
    & img {
      border-radius: 20px 20px 0px 0px;
      height: 360px;
      object-fit: cover;
    }
  }

  & .news_media__title {
    font-family: $font-Museo700;
    font-style: normal;
    font-size: 24px;
    line-height: 100%;
    color: #282828;

  }

  & .contents_modal__descr p,
  & .contents_modal__descr {
    font-family: $RobotoRegular;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 140%;
    letter-spacing: 0;
    color: #282828;
    padding: 0 !important;
  }

  & .green_messs {
    color: #68727D !important;
  }

  & .contents_modal__descr {
    padding-bottom: 55px;
    height: auto;
  }
}

</style>
